import { render, staticRenderFns } from "./ProfileActionsDropdown.vue?vue&type=template&id=23504df6&"
import script from "./ProfileActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileActionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports